import React, {useState, useEffect} from 'react'

const MenuBar = () => {

    const  menubar_toggle = () =>{
        const body_tag = document.getElementsByTagName('body')[0];

        const menu_positions = document.getElementById('menu-bar').getAttribute("menu");

        if(menu_positions === "open"){
            body_tag.setAttribute('menu' , "close" );
            document.getElementById('menu-bar').setAttribute('menu' , "close" );
        }else{
            body_tag.setAttribute('menu' , "open");
            document.getElementById('menu-bar').setAttribute('menu' , "open" );
        };
    };

    

    return (
        <>
            <div className="right-side-size" onClick={menubar_toggle}></div>
            <div id="menu-bar" onClick={menubar_toggle}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </>
    )
}

export default MenuBar